export enum AppRoutesSearchParams {
  pageIdInViewportOnInit = 'page_id_in_viewport_on_init',
  chronologyEntryIdOnInit = 'chronology_entry_id_on_init',
  cloneStartedOnInit = 'clone_started_on_init',
  from = 'from',
}
